/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Error from '@material-ui/icons/Error';
import Typography from '@material-ui/core/Typography';
import ReactHtmlParser from 'react-html-parser';
import formatString from './Helper/Helper';

const styles = {
    errorMsg: {
        textAlign: 'left',
        color: '#f44336',
        backgroundColor: '#FFF',
        padding: '3%',
        boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)',
        width: '94%',
        wordWrap: 'break-word',
    },
    noShadowErrorMsg: {
        textAlign: 'left',
        color: '#f44336',
        backgroundColor: '#FFF',
        padding: '3%',
        width: '100%',
        wordWrap: 'break-word',
    },
    icon: {
        marginTop: '-4px',
        marginRight: '4px',
        float: 'left',
    },
};

const ErrorMessage = (props) => {
    const { noShadow, error } = props;
    if (error) {
        return (
            <Typography
                align="left"
                variant="body2"
                style={(!noShadow) ? styles.errorMsg : styles.noShadowErrorMsg}
            >
                <Error style={styles.icon} color="error" />
                <span data-testid="errorMessage" id="ErrorMessage"> {ReactHtmlParser(formatString(error))} </span>
            </Typography>
        );
    }
    return null;
};

ErrorMessage.propTypes = {
    error: PropTypes.string.isRequired,
    noShadow: PropTypes.bool,
};

ErrorMessage.defaultProps = {
    noShadow: false,
};

export default ErrorMessage;
